const notice = () => import('@/page/prompt/notice')
const verify = () => import('@/page/prompt/verify')

const promptRouter = [{
    path: '/notice',
    name: 'notice',
    component: notice
}, {
    path: '/verify',
    name: 'verify',
    component: verify
}]

export default promptRouter


// WEBPACK FOOTER //
// ./src/router/prompt.js